<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
}
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
  Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

.el-submenu [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item.is-active {
  background: #ecf5ff;
  color: #409eff;
}

.el-menu-item [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar {
  padding: 10px;
  //border:1px solid #dfe6ec;
  margin: 10px 0px;

  .el-form-item {
    margin-bottom: 10px;
  }
}

.el-table th {
  background-color: #e6effb !important;
}

.el-table__footer-wrapper thead div,
.el-table__header-wrapper thead div {
  background-color: #e6effb !important;
}

.el-checkbox {
  color: #ffffff !important;
}

.remember {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #ffffff !important;
  }
}

.el-checkbox__label {
  color: #32475c !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.toolbar {
  background: #ebeef5;

  .toolbar-filter {
    // width: 100%;
    .toolbar-filter-date {
      width: 100%;
    }

    // .el-form-item__label{
    // 	width: 72px !important;
    // 	height: 32px !important;
    // 	line-height: 32px !important;
    // 	padding-right: 8px !important;
    // }
    .el-form-item__content {
      width: calc(100% - 92px) !important;
      line-height: 32px;
    }

    .el-input__icon {
      line-height: 32px !important;
    }

    .el-icon-date {
      line-height: 26px !important;
    }

    .el-range-separator {
      line-height: 24px !important;
    }
  }

  .el-input__inner {
    background: rgba(255, 255, 255, 1);
    // border: 1px solid rgba(252, 200, 200, 1) !important;
    opacity: 1;
    height: 32px;
    line-height: 32px;
    border-radius: 6px;
    padding-right: 2px !important;
  }

  .tools-search {
    width: 90px;
    height: 32px;
    background: #409eff;
    opacity: 1;
    border-radius: 5px;
    color: #ffffff;
    font-size: 14px;
    padding: 9px 20px;
    font-family: Source Han Sans CN;
  }

  .tools-search:focus {
    background: #409eff;
    color: #ffffff;
  }

  .tools-search:hover {
    background: #409eff;
    color: #ffffff;
  }

  .tools-other {
    width: 90px;
    height: 32px;
    // background: rgba(255, 244, 244, 1);
    border: 1px solid #409eff;
    opacity: 1;
    border-radius: 5px;
    color: #409eff;
    font-size: 14px;
    padding: 9px 20px;
    font-family: Source Han Sans CN;
  }

  .tools-other:hover {
    // background: rgba(255, 244, 244, 1);
    border: 1px solid #409eff;
    color: #409eff;
  }

  .tools-other:focus {
    background: rgba(255, 244, 244, 1);
    border: 1px solid #409eff;
    color: #409eff;
  }
}

.tool-page {
  margin: 20px 0px;
  text-align: right;
}

.xuanbei-dialog-foot {
  .cancel {
    width: 110px;
    height: 32px;
    line-height: 2px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #409eff;
    opacity: 1;
    border-radius: 5px;
    color: #409eff;
    font-size: 16px;
  }

  .cancel:focus {
    background: rgba(255, 255, 255, 1);
    border: 1px solid #409eff;
    color: #409eff;
  }

  .cancel:hover {
    background: rgba(255, 255, 255, 1);
    border: 1px solid #409eff;
    color: #409eff;
  }

  .submit {
    width: 110px;
    height: 32px;
    line-height: 2px;
    background: #409eff;
    border-color: #409eff;
    opacity: 1;
    border-radius: 5px;
    font-size: 16px;
    color: #ffffff;
  }

  .submit:focus {
    background: #409eff;
    border-color: #409eff;
    opacity: 1;
    color: #ffffff;
  }

  .submit:hover {
    background: #409eff;
    border-color: #409eff;
    opacity: 1;
    color: #ffffff;
  }
}

@media screen and (max-width: 1368px) {
  .el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 12px;
    cursor: pointer;
    -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }
  .el-submenu .el-menu-item {
    min-width: 152px !important;
    width: calc(100% - 85px) !important;
    height: 42px !important;
    line-height: 42px !important;
    padding: 0 30px !important;
  }
  .toolbar {
    padding: 10px 10px 18px;

    .toolbar-filter {
      .el-form-item__label {
        height: 26px !important;
        line-height: 26px !important;
        font-size: 12px !important;
      }
    }

    .order-label-select {
      height: 24px !important;
      line-height: 24px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 24px !important;
        line-height: 24px !important;
        font-size: 12px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 24px !important;
      }

      .el-icon-date {
        line-height: 16px !important;
      }

      .el-range-separator {
        line-height: 16px !important;
        font-size: 12px !important;
      }
    }

    .el-form-item__content {
      height: 26px !important;
      line-height: 26px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 26px !important;
        line-height: 26px !important;
        font-size: 12px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 24px !important;
      }

      .el-icon-date {
        line-height: 16px !important;
      }

      .el-range-separator {
        line-height: 16px !important;
        font-size: 12px !important;
      }
    }

    .tools-search {
      width: 72px;
      height: 26px;
      background: #409eff;
      opacity: 1;
      border-radius: 4px;
      color: #ffffff;
      font-size: 14px;
      padding: 5px 12px;
      font-family: Source Han Sans CN;
    }

    .tools-other {
      width: 72px;
      height: 26px;
      background: #e6effb;
      border: 1px solid #b4bccc;
      opacity: 1;
      border-radius: 4px;
      color: #b4bccc;
      font-size: 14px;
      padding: 5px 12px;
      font-family: Source Han Sans CN;
    }
  }
  .el-table th {
    background-color: #e6effb !important;
    padding: 6px 0px !important;
  }
  .el-table td {
    padding: 6px 0px !important;
  }
  .el-table .cell {
    font-size: 12px !important;
    line-height: 16px !important;
  }
  .el-table .cell .el-button {
    height: 20px !important;
    line-height: 20px !important;
    font-size: 12px !important;
    padding: 0px 10px !important;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 16px 12px !important;

      .el-form {
        .el-form-item {
          margin-bottom: 12px !important;

          .el-form-item__label {
            width: 100px;
            height: 32px !important;
            line-height: 32px !important;
            text-align: left;
            font-size: 12px !important;
          }

          .el-form-item__content {
            line-height: 32px !important;
            text-align: left;
            font-size: 12px !important;

            .el-input__inner {
              height: 32px !important;
              line-height: 32px !important;
            }

            .el-input__icon {
              line-height: 32px !important;
            }
          }
        }

        .el-button {
          padding: 8px 16px !important;
        }

        .del-icon {
          padding: 8px !important;
        }
      }
    }
  }

  .xuanbei-dialog-foot {
    .cancel {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #409eff;
      opacity: 1;
      border-radius: 5px;
      color: #409eff;
      font-size: 16px;
    }

    .submit {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: #409eff;
      border-color: #409eff !important;
      opacity: 1;
      border-radius: 5px;
      font-size: 16px;
      color: #ffffff;
    }
  }
}

@media screen and (min-width: 1369px) and (max-width: 1441px) {
  .el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 12px;
    cursor: pointer;
    -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }
  .el-submenu .el-menu-item {
    min-width: 162px !important;
    width: calc(100% - 85px) !important;
    height: 52px !important;
    line-height: 52px !important;
    padding: 0 36px !important;
  }
  .toolbar {
    padding: 13px 14px 10px !important;

    .toolbar-filter {
      .el-form-item__label {
        height: 30px !important;
        line-height: 30px !important;
        font-size: 14px !important;
      }
    }

    .order-label-select {
      height: 30px !important;
      line-height: 30px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 30px !important;
        line-height: 30px !important;
        font-size: 14px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 28px !important;
      }

      .el-icon-date {
        line-height: 20px !important;
      }

      .el-range-separator {
        line-height: 20px !important;
        font-size: 14px !important;
      }
    }

    .el-form-item__content {
      height: 28px !important;
      line-height: 28px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 28px !important;
        line-height: 28px !important;
        font-size: 14px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 28px !important;
      }

      .el-icon-date {
        line-height: 20px !important;
      }

      .el-range-separator {
        line-height: 20px !important;
        font-size: 14px !important;
      }
    }

    .tools-search {
      width: 72px;
      height: 28px;
      background: #409eff;
      opacity: 1;
      border-radius: 4px;
      color: #ffffff;
      font-size: 14px;
      padding: 5px 12px;
      font-family: Source Han Sans CN;
    }

    .tools-other {
      width: 72px;
      height: 28px;
      background: #e6effb;
      border: 1px solid #b4bccc;
      opacity: 1;
      border-radius: 4px;
      color: #b4bccc;
      font-size: 14px;
      padding: 5px 12px;
      font-family: Source Han Sans CN;
    }
  }
  .el-table th {
    background-color: #e6effb !important;
    padding: 8px 0px !important;
  }
  .el-table td {
    padding: 8px 0px !important;
  }
  .el-table .cell {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .el-table .cell .el-button {
    height: 22px !important;
    line-height: 22px !important;
    font-size: 14px !important;
    padding: 0px 12px !important;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 16px 14px !important;

      .el-form {
        .el-form-item {
          margin-bottom: 18px !important;

          .el-form-item__label {
            width: 100px;
            height: 36px !important;
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;
          }

          .el-form-item__content {
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;

            .el-input__inner {
              height: 36px !important;
              line-height: 36px !important;
              padding-right: 2px !important;
            }

            .el-input__icon {
              line-height: 36px !important;
            }
          }
        }

        .el-button {
          padding: 8px 16px !important;
        }

        .del-icon {
          padding: 8px !important;
        }
      }
    }
  }

  .xuanbei-dialog-foot {
    .cancel {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #409eff;
      opacity: 1;
      border-radius: 5px;
      color: #409eff;
      font-size: 16px;
    }

    .submit {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: #409eff;
      border-color: #409eff !important;
      opacity: 1;
      border-radius: 5px;
      font-size: 16px;
      color: #ffffff;
    }
  }
}

@media screen and (min-width: 1442px) and (max-width: 1681px) {
  .el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 12px;
    cursor: pointer;
    -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }
  .el-submenu__title {
    font-size: 14px !important;
  }
  .el-menu-item {
    font-size: 14px !important;
  }
  .el-submenu .el-menu-item {
    min-width: 180px !important;
    // width: calc( 100% - 85px ) !important;
    height: 60px !important;
    line-height: 60px !important;
    padding: 0 36px !important;
  }
  .toolbar {
    padding: 18px 16px 10px !important;

    .el-form-item__label {
      height: 32px !important;
      line-height: 32px !important;
      font-size: 14px !important;
    }

    .order-label-select {
      height: 32px !important;
      line-height: 32px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 32px !important;
        line-height: 32px !important;
        font-size: 14px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 32px !important;
      }

      .el-icon-date {
        line-height: 26px !important;
      }

      .el-range-separator {
        line-height: 26px !important;
        font-size: 14px !important;
      }
    }

    .el-form-item__content {
      height: 32px !important;
      line-height: 32px !important;

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 32px !important;
        line-height: 32px !important;
        font-size: 14px !important;
        padding-right: 2px !important;
      }

      .el-input__icon {
        line-height: 32px !important;
      }

      .el-icon-date {
        line-height: 26px !important;
      }

      .el-range-separator {
        line-height: 26px !important;
        font-size: 14px !important;
      }
    }

    .tools-search {
      width: 82px;
      height: 32px;
      background: #409eff;
      opacity: 1;
      border-radius: 4px;
      color: #ffffff;
      font-size: 14px;
      padding: 8px 12px;
      font-family: Source Han Sans CN;
    }

    .tools-other {
      width: 82px;
      height: 32px;
      background: #e6effb;
      border: 1px solid #b4bccc;
      opacity: 1;
      border-radius: 4px;
      color: #b4bccc;
      font-size: 14px;
      padding: 9px 12px;
      font-family: Source Han Sans CN;
    }

    .el-range-input {
      font-size: 14px !important;
    }
  }
  .el-table th {
    background-color: #e6effb !important;
    padding: 14px 0px !important;
  }
  .el-table td {
    padding: 14px 0px !important;
  }
  .el-table .cell {
    font-size: 14px !important;
    line-height: 24px !important;
  }
  .el-table .cell .el-button {
    height: 24px !important;
    line-height: 24px !important;
    font-size: 14px !important;
    padding: 0px 10px !important;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 16px 14px !important;

      .el-form {
        .el-form-item {
          margin-bottom: 18px !important;

          .el-form-item__label {
            width: 100px;
            height: 36px !important;
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;
          }

          .el-form-item__content {
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;

            .el-input__inner {
              height: 36px !important;
              line-height: 36px !important;
            }

            .el-input__icon {
              line-height: 36px !important;
            }
          }
        }

        .el-button {
          padding: 8px 16px !important;
        }

        .del-icon {
          padding: 8px !important;
        }
      }
    }
  }

  .xuanbei-dialog-foot {
    .cancel {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #409eff;
      opacity: 1;
      border-radius: 5px;
      color: #409eff;
      font-size: 16px;
    }

    .submit {
      width: 110px;
      height: 32px;
      line-height: 2px;
      background: #409eff;
      border-color: #409eff !important;
      opacity: 1;
      border-radius: 5px;
      font-size: 16px;
      color: #ffffff;
    }
  }
}

@media screen and (min-width: 1770px) {
  .toolbar-filter {
    .b-10 {
      margin-bottom: -10px !important;
    }
  }
}

@media screen and (min-width: 1770px) {
  .el-submenu__title {
    font-size: 16px;
    color: #303133;
    padding: 0 16px;
    cursor: pointer;
    -webkit-transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
  }
  .el-submenu__title {
    font-size: 16px !important;
  }
  .el-menu-item {
    height: 66px !important;
    line-height: 66px !important;
    font-size: 16px !important;
  }
  .el-submenu .el-menu-item {
    min-width: 180px !important;
    // width: calc( 100% - 85px ) !important;
    height: 66px !important;
    line-height: 66px !important;
    padding: 0 36px !important;
  }
  .toolbar {
    padding: 18px 16px 8px !important;

    .el-form-item__label {
      height: 36px !important;
      line-height: 36px !important;
      font-size: 16px !important;
    }

    .el-form-item__content {
      line-height: 36px !important;

      .el-date-editor .el-range__icon {
        font-size: 16px;
      }

      .el-input__inner {
        background: white;
        border: 1px solid #b4bccc !important;
        opacity: 1;
        border-radius: 4px;
        height: 36px !important;
        line-height: 36px !important;
        font-size: 16px !important;
      }

      .el-input__icon {
        line-height: 36px !important;
      }

      .el-icon-date {
        line-height: 28px !important;
      }

      .el-range-separator {
        line-height: 28px !important;
        font-size: 16px !important;
      }
    }

    .el-select {
      width: 80%;
    }

    .el-row {
      .el-form-item {
        width: calc(100% - 10px);
        margin-bottom: 12px;
      }
    }

    .tools-search {
      width: 82px;
      height: 36px;
      background: #409eff;
      opacity: 1;
      border-radius: 4px;
      color: #ffffff;
      font-size: 16px;
      padding: 8px 12px;
      font-family: Source Han Sans CN;
    }

    .tools-other {
      width: 82px;
      height: 36px;
      background: #e6effb;
      border: 1px solid #b4bccc;
      opacity: 1;
      border-radius: 4px;
      color: #b4bccc;
      font-size: 16px;
      padding: 8px 12px;
      font-family: Source Han Sans CN;
    }

    .el-range-input {
      font-size: 16px !important;
    }
  }
  .el-table th {
    background-color: #e6effb !important;
    padding: 14px 0px !important;
  }
  .el-table td {
    padding: 14px 0px !important;
  }
  .el-table .cell {
    font-size: 16px !important;
    line-height: 24px !important;
  }
  .el-table .cell .el-button {
    height: 28px !important;
    line-height: 28px !important;
    font-size: 14px !important;
    padding: 0px 10px !important;
  }
  .el-dialog {
    .el-dialog__body {
      padding: 16px 14px !important;

      .el-form {
        .el-form-item {
          margin-bottom: 18px !important;

          .el-form-item__label {
            width: 100px;
            height: 36px !important;
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;
          }

          .el-form-item__content {
            height: 36px !important;
            line-height: 36px !important;
            text-align: left;
            font-size: 14px !important;

            .el-input__inner {
              height: 36px !important;
              line-height: 36px !important;
            }

            .el-input__icon {
              line-height: 36px !important;
            }
          }
        }

        .el-button {
          padding: 8px 16px !important;
        }

        .del-icon {
          padding: 8px !important;
        }
      }
    }
  }

  // .xuanbei-dialog-foot{
  // 	.cancel{
  // 		width:110px;
  // 		height:32px;
  // 		line-height: 2px;
  // 		background:rgba(255,255,255,1);
  // 		border:1px solid rgba(255,60,46,1);
  // 		opacity:1;
  // 		border-radius:5px;
  // 		color: rgba(255,66,64,1);
  // 		font-size: 16px;
  // 	}
  // 	.submit{
  // 		width:110px;
  // 		height:32px;
  // 		line-height: 2px;
  // 		background:rgba(255,66,64,1);
  // 		border-color:rgba(255,66,64,1) !important;
  // 		opacity:1;
  // 		border-radius:5px;
  // 		font-size: 16px;
  // 		color: #ffffff;
  // 	}
  // }
}

.el-button--primary {
  color: #fff;
  background-color: #409eff !important;
  border-color: #409eff !important;
}

.el-button--primary:hover {
  background-color: #409eff !important;
  border-color: #409eff !important;
}

.el-button--primary:focus {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?cdbfc214